<div class="row" *ngIf="patient">
  <div class="col">
    <mat-card class="cardWithShadow">
      <mat-card-content>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex flex-column">
            <div class="d-flex align-items-center m-b-8">
              <h6 class="m-0 f-w-600 f-s-16 m-r-16">
                {{ patient.nome + " " + patient.cognome | titlecase }}
              </h6>

              <div class="d-flex align-items-center m-r-16">
                <small class="text-muted m-l-4">({{
                    calcolaEta(patient.dataNascita)
                  }} {{'YEARS' | translate}} - {{ patient.sesso }})</small>
              </div>

            </div>

            <div class="d-flex flex-column align-items-start">
              <div class="d-flex align-items-center">
                <i-tabler name="map-pin" class="icon-14 m-r-4"></i-tabler>
                <span>{{ patient.indirizzoResidenza + ", " + patient.cittaResidenza }}</span>
              </div>
            
              <div class="d-flex align-items-center">
                <i-tabler name="mail" class="icon-14 m-r-4"></i-tabler>
                <span>{{ patient.email }}</span>
              </div>
            
              <div class="d-flex align-items-center">
                <i-tabler name="phone" class="icon-14 m-r-4"></i-tabler>
                <span>{{ patient.telefono }}</span>
              </div>
            </div>
            
          </div>

          <button
            *ngIf="authService.isAdminRoles()"
            type="button"
            mat-flat-button
            color="warn"
            class="m-l-auto"
            (click)="exitPatient()"
          >
            {{'EXIT' | translate}}
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
